"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newOpenQuestionPin = void 0;
const lodash_1 = require("lodash");
const models_1 = require("../../models");
const newOpenQuestionPin = (layout) => {
    const basePin = {
        type: 'OPEN_QUESTION',
        settings: {
            layout: layout.key,
            backgroundColor: layout.backgroundColor,
            backgroundImage: layout.backgroundImage,
            caseSensitive: true, // true by default to make it a strict equal
            diacriticSensitive: true, // true by default to make it a strict equal
            maximumNumberOfUploadsPerStudent: models_1.NUMBER_OF_IMAGES_ALLOWED.zero,
            showStudentNames: false,
            explanation: null,
            questionId: layout.layoutParts.TITLE?.id,
            layoutParts: (0, lodash_1.mapValues)(layout.layoutParts, (comp) => comp?.id),
        },
        teacherSettings: {
            correctAnswers: [],
        },
        pinComponents: [...Object.values(layout.layoutParts), ...layout.pinComponents],
    };
    if ('backgroundTransparency' in layout && layout.backgroundTransparency !== undefined) {
        basePin.settings.backgroundTransparency = layout.backgroundTransparency;
    }
    return basePin;
};
exports.newOpenQuestionPin = newOpenQuestionPin;
//# sourceMappingURL=open-question-pin.js.map